/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_NavInputs */

const en_mk_sol_agensi_nav = /** @type {(inputs: Mk_Sol_Agensi_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agencies & studios`)
};

const id_mk_sol_agensi_nav = /** @type {(inputs: Mk_Sol_Agensi_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agensi & rumah produksi`)
};

/**
* | output |
* | --- |
* | "Agencies & studios" |
*
* @param {Mk_Sol_Agensi_NavInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_nav = /** @type {((inputs?: Mk_Sol_Agensi_NavInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_NavInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_nav(inputs)
	return en_mk_sol_agensi_nav(inputs)
});